module.exports = __webpack_public_path__ + "static/media/technology-tailoring.ab3f5bb0.svg";